export const fileTypes: string =
  process.env.REACT_APP_DOCUMENT_SPECIFIQUE_ACCEPTED_TYPES ||
  'application/pdf,image/png,image/jpeg';
export const maxFileSize =
  process.env.REACT_APP_DOCUMENT_SPECIFIQUE_MAX_SIZE || '10485760';

export const PROFILS_DESTINATAIRES = ['GF', 'FO', 'AF'];
